export const focusRefChild = <T extends HTMLElement>(
  containerRef: React.RefObject<T>
) => {
  if (!containerRef.current) {
    return;
  }

  const elementToFocus =
    ((containerRef.current.querySelector('h1, h2, h3, h4, h5, h6') ??
      containerRef.current?.firstElementChild) as HTMLElement) ??
    containerRef.current;
  if (elementToFocus.getAttribute('tabindex') === null) {
    elementToFocus.tabIndex = -1;
  }

  elementToFocus.focus();
};
